<template>
	<div class="appSelection">
		<div class="as_left">
			<img
				class="leftToolBackground"
				src="@/assets/img/appCenter/leftToolBackground.png"
			/>
			<div
				v-for="(item, index) in dataList"
				:key="index"
				:class="{ active: activeIndex === index }"
				@click="handleActive(index)"
			>
				{{ item.categoryName }}
			</div>
		</div>
		<div class="as_right" :ref="`cardListRef`">
			<div class="as_r_inputArea">
				<el-input
					v-model="searchValue"
					style="width: 325px"
					:placeholder="lang.input_app_name"
					@keyup.enter.native="getData"
				>
					<i
						slot="suffix"
						class="searchInputIcon el-icon-search"
						@click="getData"
					></i>
				</el-input>
			</div>
			<div class="as_r_item" v-for="(item, index) in dataList" :key="index">
				<div v-if="item.clientUserThirdPartyAccountResponses.length>0" class="as_r_item_title" :ref="`cardTitle${index}Ref`">
					{{ item.categoryName }}
				</div>
				<div
					class="as_r_box"
					v-if="item.clientUserThirdPartyAccountResponses.length>0"
				>
					<div
						class="as_fi_item"
						v-for="(item2, index2) in item.clientUserThirdPartyAccountResponses"
						:key="index2 + '-' + index"
						@click="openUrl(item2.link)"
					>
						<div class="as_fi_i_top">
							<div class="as_fi_i_t_avatarArea">
								<div class="as_fi_i_t_a_a_avatar">
									<img
										v-if="item2.logo"
										:src="require(`@/assets/img/logos/${item2.logo}`)"
										alt="logo"
									/>
									<div v-else class="noAvatar" :style="`background-color:${item2.backgroundColor}`">
										<span :style="`color:${item2.avatarColor}`">{{item2.avatarName}}</span>
									</div>
								</div>
							</div>
							<div class="as_fi_i_t_a_message">
								<div class="as_fi_i_t_a_m_name">{{ item2.platformName }}</div>
								<div class="as_fi_i_t_a_m_intro">{{ item2.intro }}</div>
							</div>
						</div>
						<div class="as_fi_i_bottom">
							<div class="as_fi_i_b_btnArea">
								<span class="linkBtn">{{ lang.ImmediateAccess }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dataListValue from "./dataList.js";
export default {
	name: "appSelection",
	data() {
		return {
			dataList: [],
			allDataList:[],
			activeIndex: 0,
			searchValue: "",
		};
	},
	methods: {
		openUrl(link) {
			window.open(link, "_blank");
		},
		handleActive(newIndex) {
			this.activeIndex = newIndex;
			this.$nextTick(() => {
				console.log(this.$refs[`cardListRef`].scrollTop);
				console.log(this.$refs[`cardTitle${this.activeIndex}Ref`][0].offsetTop);
				this.$refs[`cardListRef`].scrollTo(
					0,
					this.$refs[`cardTitle${this.activeIndex}Ref`][0].offsetTop - 70
				);
			});
		},
		getData() {
			if(this.searchValue){
				// console.log(this.searchValue)
				let _copyData = JSON.parse(JSON.stringify(this.allDataList));
				_copyData.forEach(i=>{
					i.clientUserThirdPartyAccountResponses = i.clientUserThirdPartyAccountResponses.filter(i2=>{
						return new RegExp(this.searchValue, 'i').test(i2.platformName);
					})
				})
				_copyData = _copyData.filter(i=>i.clientUserThirdPartyAccountResponses.length>0)
				this.dataList = _copyData;
				// _copyData = _copyData.filter(i=>)
			}else{
				this.dataList = JSON.parse(JSON.stringify(this.allDataList))
			}
			this.$forceUpdate();
			// console.log(this.searchValue);
		},
	},
	watch:{
		// searchValue(newValue){
		// 	if(newValue){
		// 		console.log(newValue)
		// 	}else{
		// 		this.dataList = JSON.parse(JSON.stringify(this.allDataList))
		// 	}
		// },
	},
	mounted() {
		this.dataList = dataListValue;
		this.allDataList = dataListValue;
		this.$nextTick(() => {
			const cardListRef = this.$refs.cardListRef;
			const cardItems = cardListRef.children;
			cardListRef.addEventListener("scroll", () => {
				for (let i = 0; i < cardItems.length; i++) {
					const card = cardItems[i];
					const rect = card.getBoundingClientRect();
					const listRect = cardListRef.getBoundingClientRect();
					if (rect.top >= listRect.top && rect.top <= listRect.bottom) {
						this.activeIndex = i;
						break;
					}
				}
			});
		});
	},
};
</script>

<style lang="scss" scoped>
.appSelection {
	width: 100vw;
	height: calc(100vh - 50px);
	overflow: auto;
	box-sizing: border-box;
	padding: 0px;
	display: flex;
	.as_left {
		width: clamp(200px, 12vw, 280px);
		min-width: 200px;
		height: 100%;
		background-color: #fff;
		// border-radius: 8px;
		box-sizing: border-box;
		padding: 10px;
		overflow-x: hidden;
		position: relative;
		.leftToolBackground {
			width: 100%;
			height: auto;
			position: absolute;
			bottom: 0;
			left: 0;
			z-index:1;
		}

		div {
			width: 100%;
			height: 40px;
			padding: 10px 15px;
			box-sizing: border-box;
			border-radius: 6px;
			// background-color: #fff;
			margin-bottom: 10px;
			font-size: 16px;
			cursor: pointer;
			margin-right: 10px;
			position: relative;
			z-index:2;
			transition: all 0.3s ease;
			&:hover {
				background-color: #e9f2fc;
			}
			&.active {
				background-color: #e9f2fc;
				color: #0354d7;
			}
		}
	}
	.as_right {
		//width: calc(100% - 220px - 10px);
		flex:1;
		height: 100%;
		// margin-left: 10px;
		overflow-x: hidden;
		box-sizing: border-box;
		padding: 0 10px 0 20px;
		background-image: url("@/assets/img/appCenter/background2.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;
		.as_r_inputArea {
			width: auto;
			height: 50px;
			position: absolute;
			top: 12px;
			right: 10px;
			.searchInputIcon {
				width: 20px;
				height: 20px;
				position: relative;
				top: 10px;
				right: 5px;
				font-size: 19px;
				cursor: pointer;
			}
		}
		.as_r_item {
			width: 100%;
			height: auto;
			.as_r_item_title {
				font-size: 20px;
				font-weight: bold;
				margin-bottom: 10px;
				width: 100%;
				height: 40px;
				display: flex;
				align-items: center;
				margin: 10px 0 25px 0;
			}
			.as_r_box {
				width: 100%;
				height: auto;
				display: flex;
				flex-wrap: wrap;
				.as_fi_item {
					// width: calc((100% / 5) - 15px + (15px / 5));
					height: 135px;
					border-radius: 8px;
					background-color: #fff;
					margin-right: 15px;
					margin-bottom: 15px;
					box-sizing: border-box;
					padding: 0 20px;
					cursor: pointer;
					transition: 0.2s;
					// &:nth-child(5n) {
					// 	margin-right: 0;
					// }
					&:hover {
						box-shadow: 0px 6px 30px 5px #00000015;
					}
					.as_fi_i_top {
						width: 100%;
						height: calc(100% - 49px);
						display: flex;
						align-items: center;
						justify-content: center;
						box-sizing: border-box;
						.as_fi_i_t_avatarArea {
							width: 60px;
							height: 60px;
							font-size: 16px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							.as_fi_i_t_a_a_avatar {
								width: 60px;
								height: 60px;
								border-radius: 50%;
								background-color: #fff;
								color: #000;
								display: flex;
								align-items: center;
								justify-content: center;
								overflow: hidden;
								img {
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
								.noAvatar{
									width:100%;
									height:100%;
									display:flex;
									align-items:center;
									justify-content:center;
									span{
										font-size:24px;
										font-weight:bold;
									}
								}
							}
						}
						.as_fi_i_t_a_message {
							width: calc(100% - 60px - 20px);
							height: 100%;
							display: flex;
							justify-content: center;
							flex-direction: column;
							margin-left: 15px;
							.as_fi_i_t_a_m_name {
								font-size: 18px;
								font-weight: 600;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
							.as_fi_i_t_a_m_intro {
								font-size: 14px;
								color: #999;
								margin-top: 10px;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 1;
								-webkit-box-orient: vertical;
							}
						}
					}
					.as_fi_i_bottom {
						width: 100%;
						height: 49px;
						box-sizing: border-box;
						border-top: solid 1px #dfdfdf;
						display: flex;
						align-items: center;
						padding: 0 0px;
						.as_fi_i_b_btnArea {
							width: 100%;
							display: flex;
							justify-content: flex-end;
							.linkBtn {
								display: block;
								padding: 5px 10px;
								border-radius: 6px;
								border: solid 1px #c1acfc;
								color: #c1acfc;
								font-size: 14px;
								transition: all 0.3s ease;
								cursor: pointer;
								&:hover {
									background-color: #c1acfc;
									color: #fff;
								}
							}
						}
					}
				}
				.ar_r_b_empty{
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #a1a1a1;
				}
			}
		}
	}
}

@media screen and (min-width: 2601px) {
	.as_fi_item {
		width: calc(100% / 7 - (15px * 6) / 7) !important;
	}
	.as_fi_item:nth-child(7n) {
		margin-right: 0px !important;
	}
}

@media screen and (max-width: 2600px) and (min-width: 2256px) {
	.as_fi_item {
		width: calc(100% / 6 - (15px * 5) / 6) !important;
	}
	.as_fi_item:nth-child(6n) {
		margin-right: 0px !important;
	}
}
@media screen and (max-width: 2255px) and (min-width: 1874px) {
	.as_fi_item {
		width: calc(100% / 5 - (15px * 4) / 5) !important;
	}
	.as_fi_item:nth-child(5n) {
		margin-right: 0px !important;
	}
}
@media screen and (max-width: 1873px) and (min-width: 1201px) {
	.as_fi_item {
		width: calc(100% / 4 - (15px * 3) / 4) !important;
	}
	.as_fi_item:nth-child(4n) {
		margin-right: 0px !important;
	}
}

@media screen and (max-width: 1200px){// and (min-width: 1201px) 
	.as_fi_item {
		width: calc(100% / 3 - (15px * 2) / 3) !important;
	}
	.as_fi_item:nth-child(3n) {
		margin-right: 0px !important;
	}
}

// @media screen and (max-width: 1200px) {
// 	.as_fi_item {
// 		width: calc(100% / 2 - 15px / 2) !important;
// 	}
// 	.as_fi_item:nth-child(2n) {
// 		margin-right: 0px !important;
// 	}
// }
</style>
